import React, { FunctionComponent, useContext } from 'react'
import { Button, Col, Form, Input, Row } from 'antd'
import { FormInstance } from 'antd/lib/form'
import './groupCreate.less'
import SubpageLayout from '../../../layouts/SubpageLayout'
import { LocalizationContext } from '../../../providers/LocalizationProvider'

interface GroupCreateViewProps {
  form: FormInstance
  onFinish: (v: any) => void
  createLoading: boolean
}

const GroupCreateView: FunctionComponent<GroupCreateViewProps> = (props: GroupCreateViewProps) => {
  const { t, dictionary } = useContext(LocalizationContext)
  const groupsPage = dictionary.groupsPage

  return (
    <div className='create-group'>
      <SubpageLayout title={t(groupsPage.addGroup)} page={t(dictionary.layouts.users)}>
        <Form
          form={props.form}
          name='create-group'
          onFinish={props.onFinish}
          layout='vertical'
          className='app-layout__form'
        >
          <Row gutter={[16, 32]} className='app-layout__columns-arrangement'>
            <Col xs={24} sm={24} md={10} lg={8} xl={6}>
              <Form.Item
                name='name'
                label={t(groupsPage.name)}
                rules={[{ required: true, message: t(dictionary.general.formError) }]}
              >
                <Input placeholder={t(groupsPage.name)} type='text' />
              </Form.Item>
            </Col>
          </Row>
          <Row className='app-layout__last-row'>
            <Button
              type='primary'
              htmlType='submit'
              className='app-layout__form-button'
              loading={props.createLoading}
            >
              {t(groupsPage.createGroup)}
            </Button>
          </Row>
        </Form>
      </SubpageLayout>
    </div>
  )
}

export default GroupCreateView
